import { ColoredDatePickerIcon } from "@smartsheet/lodestar-icons";
import { getClientId } from "@smartsheet/lodestar-utils";
import { CalendarIcon } from "@smartsheet/ursa-icons";
import React, { ButtonHTMLAttributes, forwardRef } from "react";
import { useI18n } from "../../../../i18n/i18n";
import { useCombinedThemeMode } from "../../../../util/theme/useCombinedThemeMode";
import { DatePickerCalendarButtonLodestar } from "../styled/DatePickerCalendarButtonLodestar";
import { DatePickerCalendarButtonUrsa } from "../styled/DatePickerCalendarButtonUrsa";

export interface DatePickerInputCalendarButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    clientId: string | undefined;
    isDisabled: boolean;
    isReadOnly: boolean;
}

export const DatePickerInputCalendarButton = forwardRef<HTMLButtonElement, DatePickerInputCalendarButtonProps>(
    ({ clientId, isDisabled, isReadOnly, ...rest }, ref) => {
        const themeMode = useCombinedThemeMode();
        const { i18n } = useI18n();

        const sharedProps = {
            ...rest,
            "aria-label": i18n._(/*i18n*/ "date picker"),
            isDisabled,
            clientId: getClientId(clientId, "dp-calendar-button"),
            ref: ref,
        };

        switch (themeMode) {
            case "oldestar":
            case "lodestar-light":
                return (
                    <DatePickerCalendarButtonLodestar {...sharedProps}>
                        <ColoredDatePickerIcon />
                    </DatePickerCalendarButtonLodestar>
                );
            case "ursa-light":
                return isDisabled || isReadOnly ? null : (
                    <DatePickerCalendarButtonUrsa
                        appearance="secondary-empty"
                        iconBefore={<CalendarIcon size={24} />}
                        size="medium"
                        {...sharedProps}
                    />
                );
        }
    }
);

DatePickerInputCalendarButton.displayName = "DatePickerInputCalendarButton";
